if (!window.__doggiInit) {
window.__doggiInit = true;

  // === Galleri (miniatyrbytte) - isolert, kan ikke stoppe resten ===
  try {
    var thumbRow = document.getElementById('dg-thumb-row');
    var mainImg = document.getElementById('dg-main-img');
    if(thumbRow && mainImg){
      thumbRow.addEventListener('click', function(e){
        try {
          var thumb = e.target.closest('.dg-thumb');
          if(!thumb) return;
          var newFull = thumb.getAttribute('data-full');
          if(!newFull) return;
          var thumbImgEl = thumb.querySelector('img');
          var oldMainSrc = mainImg.src;
          mainImg.src = newFull;
          thumbImgEl.src = oldMainSrc;
          thumb.setAttribute('data-full', oldMainSrc);
        } catch(e2) { /* stille feil, pavirker ikke resten av siden */ }
      });
    }
  } catch(e) { /* stille feil, pavirker ikke resten av siden */ }

  // === Vektvalg - isolert ===
  function selWeight(el){
    try {
      el.parentElement.querySelectorAll('.dg-weight-opt').forEach(function(o){o.classList.remove('dg-sel');});
      el.classList.add('dg-sel');
      var variantId = el.getAttribute('data-variant-id');
      var weightLabel = el.getAttribute('data-weight-label') || '';
      var buyBtn = document.getElementById('mainbuy');
      if(buyBtn && variantId){ buyBtn.setAttribute('data-product-id', variantId); }
      if(buyBtn){
        buyBtn.style.display = '';
        var labelEl = buyBtn.querySelector('.dg-buy-label');
        if(labelEl && weightLabel){ labelEl.textContent = 'Få gratis prøvepakke (' + weightLabel + ') \u2192'; }
        buyBtn.classList.remove('dg-jump');
        void buyBtn.offsetWidth;
        buyBtn.classList.add('dg-jump');
      }
      var multiBtn = document.getElementById('dg-multi-dog-cta');
      if(multiBtn){ multiBtn.style.display = 'none'; }
    } catch(e) { /* stille feil, pavirker ikke resten av siden */ }
  }

  // === Quiz-logikk - isolert ===
  var tegn = [];
  var answers = {rase:null, alder:null, vekt:null};
  function showStep(n){
    try {
      var steps = document.querySelectorAll('[data-step]');
      steps.forEach(function(s){ s.hidden = s.getAttribute('data-step') !== String(n); });
      var bar = document.getElementById('pbar');
      if(bar){ bar.style.width = (n==='result'?100:((n-1)/4)*100)+'%'; }
    } catch(e) { /* stille feil */ }
  }
  function pickOpt(el){
    try {
      var group = el.getAttribute('data-g');
      el.parentElement.querySelectorAll('.opt').forEach(function(o){o.style.background='';o.style.borderColor='rgba(255,255,255,.2)';});
      el.style.background='rgba(228,105,59,.3)'; el.style.borderColor='var(--orange)';
      if(group==='rase'){ answers.rase = el.getAttribute('data-v'); showStep(2); }
      if(group==='alder'){ answers.alder = el.getAttribute('data-v'); showStep(3); }
      if(group==='vekt'){ answers.vekt = el.getAttribute('data-v'); showStep(4); }
    } catch(e) { /* stille feil */ }
  }
  function toggleOpt(el){
    try {
      var v = el.getAttribute('data-v');
      var sel = el.style.background.indexOf('228') === -1;
      if(v==='none'){
        document.querySelectorAll('.dg-opt2').forEach(function(o){o.style.background='';o.style.borderColor='rgba(255,255,255,.2)';});
        tegn = ['none'];
        el.style.background='rgba(228,105,59,.3)'; el.style.borderColor='var(--orange)';
        return;
      }
      var noneEl = document.querySelector('[data-v="none"]');
      if(noneEl){ noneEl.style.background=''; noneEl.style.borderColor='rgba(255,255,255,.2)'; }
      tegn = tegn.filter(function(t){return t!=='none';});
      if(sel){ el.style.background='rgba(228,105,59,.3)'; el.style.borderColor='var(--orange)'; tegn.push(v); }
      else { el.style.background=''; el.style.borderColor='rgba(255,255,255,.2)'; tegn = tegn.filter(function(t){return t!==v;}); }
    } catch(e) { /* stille feil */ }
  }
  function showResult(){
    try {
      var n = tegn.filter(function(t){return t!=='none';}).length;
      var tag=document.getElementById('rtag'), h=document.getElementById('rhead'), t=document.getElementById('rtext');
      if(n===0){tag.textContent='Godt nytt';h.textContent='Ingen tegn ennå – perfekt tidspunkt';t.textContent='De fleste hunder utvikler stive ledd før eieren merker det. Å starte nå, mens hunden har det bra, er nettopp det som holder den sånn lenger.';}
      else if(n===1){tag.textContent='Verdt å følge med på';h.textContent='Vi ser ett tydelig tegn';t.textContent='Dette er akkurat der de fleste starter for sent. Full dose nå kan bremse det før det blir verre.';}
      else {tag.textContent='Bør tas på alvor';h.textContent='Flere tegn samtidig';t.textContent='Dette er ikke noe å vente med. Full dose leddkollagen, omega-3 og gurkemeie nå gir hunden din den beste sjansen til å bli aktiv igjen.';}
      if(answers.alder === '7+'){ t.textContent += ' Ved 7 år og oppover er leddene ekstra utsatt – enda en god grunn til å starte nå.'; }
      showStep('result');
    } catch(e) { /* stille feil */ }
  }

  // === Ekte kjop (hovedknapp) - isolert ===
  try {
    var btn = document.getElementById('mainbuy');
    if(btn){
      var cartUrl = btn.getAttribute('data-cart-url') || '/cart';
      var confirmUrl = '/pages/bekreft-bestilling';
      var clearUrl = cartUrl.replace(/\/cart\/?$/, '/cart/clear.js');
      var addUrl = cartUrl.replace(/\/cart\/?$/, '/cart/add.js');
      if(btn.getAttribute('data-product-id')){
        btn.addEventListener('click', function(e){
          e.preventDefault();
          try {
            var variantId = btn.getAttribute('data-product-id');
            btn.disabled = true;
            var original = btn.innerHTML;
            btn.innerHTML = 'Ett øyeblikk...';
            fetch(clearUrl, { method: 'POST' })
            .then(function(){
              return fetch(addUrl, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({ items: [{ id: variantId, quantity: 1, selling_plan: 21946794020 }] })
              });
            })
            .then(function(r){
              return r.json().then(function(data){
                if(!r.ok){ throw new Error(data.description || data.message || JSON.stringify(data)); }
                return data;
              });
            })
            .then(function(){ window.location.href = confirmUrl + window.location.search; })
            .catch(function(err){ btn.disabled = false; btn.innerHTML = original; alert('Feil: ' + err.message); });
          } catch(e2) { /* stille feil */ }
        });
      }
    }
  } catch(e) { /* stille feil, pavirker ikke resten av siden */ }

  // === Quiz-resultat sender rett til kassen med forhandsvalgt vekt - isolert ===
  window.dgQuizBuyNow = function(){
    try {
      var vektMap = { liten: 0, medium: 1, stor: 2 };
      var idx = vektMap[answers.vekt];
      var weightBtns = document.querySelectorAll('.dg-weight-opt');
      if(idx === undefined || !weightBtns[idx]){ window.location.href = '#kjop'; return; }
      var chosen = weightBtns[idx];
      var variantId = chosen.getAttribute('data-variant-id');
      if(!variantId){ window.location.href = '#kjop'; return; }
      var mainBtn = document.getElementById('mainbuy');
      var cartUrl = (mainBtn && mainBtn.getAttribute('data-cart-url')) || '/cart';
      var confirmUrl = '/pages/bekreft-bestilling';
      var clearUrl = cartUrl.replace(/\/cart\/?$/, '/cart/clear.js');
      var addUrl = cartUrl.replace(/\/cart\/?$/, '/cart/add.js');
      fetch(clearUrl, { method: 'POST' })
        .then(function(){
          return fetch(addUrl, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1, selling_plan: 21946794020 }] })
          });
        })
        .then(function(){ window.location.href = confirmUrl; })
        .catch(function(){ window.location.href = '#kjop'; });
    } catch(e) { window.location.href = '#kjop'; }
  };

  // === Quiz-popup apne/lukke - isolert ===
  try {
    window.dgOpenQuiz = function(){
      var m = document.getElementById('dg-quiz-modal');
      if(m){ m.style.display = 'flex'; document.body.style.overflow = 'hidden'; }
    };
    window.dgCloseQuiz = function(){
      var m = document.getElementById('dg-quiz-modal');
      if(m){ m.style.display = 'none'; document.body.style.overflow = ''; }
    };
  } catch(e) { /* stille feil */ }
}
